import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DataTable } from "./DashboardStyles";

interface AssessmentItem {
  lesson_link: string;
  lesson_title: string;
  lessons_completed: number;
  last_execution_activity_date: string;
}

export const AssessmentsTab = ({
  assessments,
  navigate,
}: {
  assessments: AssessmentItem[];
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  return assessments.length === 0 ? (
    <>
      <Row className="px-5">
        <Col>
          <div className="mt-5 text-center">
            {t("dashboard_assessments_no_students")}
          </div>
          <div className="mt-3 text-center">
            {t("dashboard_assessments_no_students_long")}
          </div>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs={6} md={4} lg={3} className="mx-auto">
          <img className="img-fluid" alt="" src={`${process.env.PUBLIC_URL}/assessments_robot.png`} />
        </Col>
      </Row>
    </>
  ) : (
    <>
      <DataTable>
        <thead>
          <tr>
            <th scope="col">{t("dashboard_assessments_column_title")}</th>
            <th scope="col">{t("dashboard_assessments_column_completions")}</th>
            <th scope="col">{t("dashboard_assessments_column_activity")}</th>
          </tr>
        </thead>
        <tbody>
          {assessments.map((a, index) => (
            <tr key={index}>
              <td>
                <a href={a.lesson_link} onClick={() => navigate(a.lesson_link)}>
                  {a.lesson_title}
                </a>
              </td>
              <td>{a.lessons_completed}</td>
              <td>{a.last_execution_activity_date}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </>
  );
};
